import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import isicrevfiveService from './isicrevfiveService'


const initialState = {
    isicrevfive: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
}

export const isicrevfiveSlice = createSlice({
    name: 'isicrevfive',
    initialState,
    reducers: {
        reset: (state) => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(getIsicrevfive.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getIsicrevfive.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.isicrevfive = action.payload
                state.isError = false
            })
            .addCase(getIsicrevfive.rejected, (state, action) => {
                state.isLoading = false
                state.isSuccess = false
                state.message = action.payload
                state.isError = true
            })
    }
})

export const getIsicrevfive = createAsyncThunk('isicrevfive/getIsicrevfive', async (_, thunkAPI) => {
    try {
        return await isicrevfiveService.getIsicrevfive()
    } catch (error) {
        const message = error.message
        return thunkAPI.rejectWithValue(message)
    }
})

export const { reset } = isicrevfiveSlice.actions
export default isicrevfiveSlice.reducer
